/**
 * Created by Victor Rojo on 15/5/19.
 */
import { Component }     from '@angular/core';

@Component({
  templateUrl: './Configuration.component.html',
  styleUrls: ['./Configuration.component.css']
})
export class ConfigurationComponent {

}
